import React from 'react'
import { Api } from '../../libs/api'
import Cookie from '../../../common/cookie'

class Winpop extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            eventList: [],
            dayPop: true,
            closePop: false,
        }
    }

    componentDidMount() {
        const isPop = Cookie.get('evtWinPop')
        if (isPop !== 'off') this.getList()
    }

    getList = () => {
        const opt = {
            pageSize: 5,
            f_win: 1,
            my_evt_join: 1,
        }
        this.goRd = 0
        Api.getEvents(opt).then(response => {
            if (response.data.code === '200') {
                this.goRd = 2
                this.setState({ eventList: response.data.data.eventList })
            }
        })
    }

    closePop = () => {
        if (this.state.dayPop) Cookie.set('evtWinPop', 'off', 24 * 60 * 60, '/', '.pping.kr')
        this.setState({ closePop: true })
    }

    render() {
        const { eventList, closePop, dayPop } = this.state
        if (eventList.length === 0 || closePop) return ''
        return (
            <table id="lyrPop">
                <tbody>
                    <tr>
                        <td>
                            <div className="PopMain">
                                <div className="myWinPop">
                                    <strong className="popTitle">
                                        <font className="randomN">{this.props.userName}</font>님 축하합니다.
                                        <br />
                                        <span>이벤트에 당첨되셨습니다!</span>
                                    </strong>

                                    <img
                                        src={`${process.env.REACT_APP_CDN_IMG}/img_static/img/event/evtpop_img.png`}
                                        alt="당첨을 축하합니다."
                                    />
                                    <strong className="layerTitle">이벤트 당첨 내역 확인하기</strong>
                                    <ul className="myWinList">
                                        {this.state.eventList.map((v, i) => {
                                            const key = i
                                            return (
                                                <li key={key}>
                                                    <span>{`${v.nm_evt_detail} ${v.nm_evt}`}</span>
                                                    <a
                                                        href={`/win/view/${v.idx_cat_evt}`}
                                                        title={`${v.nm_evt} 당첨자 발표`}
                                                    >
                                                        바로가기
                                                    </a>
                                                </li>
                                            )
                                        })}
                                    </ul>
                                </div>
                                <div className="popDefBtns">
                                    <button type="button" className="icon-X_close" onClick={() => this.closePop()} />
                                </div>
                                <div className="popNoToday">
                                    <span className="icheck">
                                        <input
                                            type="checkbox"
                                            id="id-todayclse"
                                            onChange={() => this.setState({ dayPop: !dayPop })}
                                            checked={dayPop}
                                        />
                                        <label htmlFor="id-todayclse">
                                            오늘 하루 보지않기
                                            <input type="hidden" />
                                        </label>
                                    </span>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        )
    }
}
export default Winpop
